export default "__VITE_ASSET__b7831a07__"